import * as React from 'react';

import { OptionsInterface } from './types';

import { DocumentGridTemplate } from './columnsRenderTemplates/DocumentGridTemplate';
import { SignDocumentGridTemplate } from './columnsRenderTemplates/SignDocumentGridTemplate';
import { HistoryGridTemplate } from './columnsRenderTemplates/HistoryGridTemplate';
import { StatusGridTemplate } from './columnsRenderTemplates/StatusGridTemplate';
import { ActionsGridTemplate } from './columnsRenderTemplates/ActionsGridTemplate';

export const options: OptionsInterface = {
  config: {
    options: {
      noDataText: 'Нет данных',
    },
  },
  columns: [
    {
      dataField: 'index',
      isKey: true,
      title: '№',
      width: '5%',
    },
    {
      dataField: 'document',
      dataFormat: (cell, row, formatExtraData, idx) => (
        <DocumentGridTemplate key={idx} cell={cell} />
      ),
      title: 'Документ',
    },
    {
      dataField: 'files',
      dataFormat: (cell, row, formatExtraData, idx) => (
        <SignDocumentGridTemplate key={idx} cell={cell} />
      ),
      title: 'Подписание документа',
    },
    {
      dataField: 'history',
      dataFormat: (cell, row, formatExtraData, idx) => (
        <HistoryGridTemplate key={idx} cell={cell} />
      ),
      title: '#',
      width: '15%',
    },
    {
      dataField: 'status',
      dataFormat: (cell, row, formatExtraData, idx) => (
        <StatusGridTemplate key={idx} cell={cell} />
      ),
      title: 'Текущий шаг',
      width: '15%',
    },
    {
      dataField: 'actions',
      dataFormat: (cell, row, formatExtraData, idx) => {
        return (
          <ActionsGridTemplate
            key={idx}
            cell={cell}
            handleClick={row.handleClick}
            isLoading={row.isLoading}
          />
        );
      },
      title: 'Действия',
      // width: '15%',
    },
  ],
};
